import { render, staticRenderFns } from "./trawl-header.vue?vue&type=template&id=6b7ca538"
import script from "./trawl-header.vue?vue&type=script&lang=js"
export * from "./trawl-header.vue?vue&type=script&lang=js"
import style0 from "./trawl-header.vue?vue&type=style&index=0&id=6b7ca538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports